import React, { useState } from "react";
import Box from "@mui/material/Box";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Form, useFormikContext } from "formik";
import Progress from "./Progress";
import RaceMode from "src/components/wizard/Footer/RaceMode";
import ChargeSection from "src/components/capture/ReceivingWizard/AdditionalCharges/ChargeSection";
import EmptyAdditionalCharges from "src/components/capture/ReceivingWizard/AdditionalCharges/EmptyAdditionalCharges";
import RateCategoryPickerModal from "src/components/capture/ReceivingWizard/AdditionalCharges/RateCategoryPickerModal";
import RateMultiSelectModal from "src/components/capture/ReceivingWizard/AdditionalCharges/RateMultiSelectModal";

const styles = {
  content: {
    mt: 2,
    flexGrow: 1,
    overflowY: "auto",
  },
  actions: {
    px: 3,
    pb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

export default function AdditionalChargesForm({
  inventoryRequest,
  project,
  currentItemIndex,
  totalItems,
  onClose,
  onNoAdditionalCharges,
}) {
  const { isSubmitting, values, setValues } = useFormikContext();
  const [openCategoryPicker, setOpenCategoryPicker] = useState(false);
  const [openRatePicker, setOpenRatePicker] = useState(null);

  const list = Object.entries(values).map(([key, value]) => ({
    key,
    entries: Object.entries(value),
  }));

  const handleAddBillingCharges = () => {
    setOpenCategoryPicker(true);
  };

  const handleSelectCategory = categoryKey => {
    setOpenCategoryPicker(false);
    if (categoryKey === "oneTimeCharge") {
    } else if (categoryKey === "noAdditionalCharges") {
      onNoAdditionalCharges();
    } else {
      setOpenRatePicker({ categoryKey });
    }
  };

  return (
    <Form style={{ height: "100%" }}>
      <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100%">
        <DialogContent sx={styles.content}>
          {list.length === 0 ? (
            <EmptyAdditionalCharges
              description="Outbound orders may include extra charges for materials, labor, or inspection services."
              onAddBillingCharges={handleAddBillingCharges}
            />
          ) : (
            list.map(sec => <ChargeSection key={sec.key} section={sec} />)
          )}
        </DialogContent>
        <Progress step={currentItemIndex} totalSteps={totalItems} />
        <DialogActions sx={styles.actions}>
          <RaceMode
            startTime={inventoryRequest.pickingStartTime}
            completeTime={inventoryRequest.pickingCompleteTime}
          />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting || list.length === 0}
          >
            Continue
          </Button>
        </DialogActions>
      </Box>

      {openCategoryPicker && (
        <RateCategoryPickerModal
          onClose={() => setOpenCategoryPicker(false)}
          onSelect={handleSelectCategory}
          hasExistingCharges={list.length > 0}
        />
      )}

      {openRatePicker && (
        <RateMultiSelectModal
          onClose={() => setOpenRatePicker(null)}
          categoryKey={openRatePicker.categoryKey}
          rates={project?.[openRatePicker.categoryKey] || {}}
          initialSelected={Object.keys(
            {
              materialRates: values?.materialCharges,
              laborRates: values?.laborCharges,
              openInspectRates: values?.openInspectCharges,
              equipmentRates: values?.equipmentCharges,
            }[openRatePicker.categoryKey] || {}
          )}
        />
      )}
    </Form>
  );
}
